var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingTypeOneTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.478,
    height: 86,
    viewBox: "0 0 73.478 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_18967",
    x: 0,
    y: 0,
    width: 71,
    height: 86,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff983c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcd56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff983c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9116",
    "data-name": "Group 9116",
    transform: "translate(-34.291 -284.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 34.29, 284.95)",
    filter: "url(#Rectangle_18967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18967-2",
    "data-name": "Rectangle 18967",
    d: "M8.125,0h36.75A8.125,8.125,0,0,1,53,8.125v51.75A8.125,8.125,0,0,1,44.875,68H8.125A8.125,8.125,0,0,1,0,59.875V8.125A8.125,8.125,0,0,1,8.125,0Z",
    transform: "translate(9 6)",
    fill: "#E75A7C"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_41033",
    "data-name": "Path 41033",
    d: "M11.631,2.1c0,1.067-1.4,2.1-3.1,2.1H3.1C1.393,4.2,0,3.166,0,2.1S1.4,0,3.1,0H8.531C10.234,0,11.631,1.034,11.631,2.1Z",
    transform: "translate(63.976 287.044)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41034",
    "data-name": "Path 41034",
    d: "M43.162,3a2.875,2.875,0,0,0-2.936-3H2.986A2.913,2.913,0,0,0,0,3V52.654a3.014,3.014,0,0,0,2.984,3.115H34.019l9.143-10.1Z",
    transform: "translate(47.794 296.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41035",
    "data-name": "Path 41035",
    d: "M0,2.549v7.37L9.334,0H3.386C1.673,0,0,.836,0,2.549Z",
    transform: "translate(81.79 342.425)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18968",
    "data-name": "Rectangle 18968",
    d: "M4.5,0h15a4.5,4.5,0,0,1,0,9H4.5a4.5,4.5,0,0,1,0-9Z",
    transform: "translate(57.29 288.947)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18969",
    "data-name": "Rectangle 18969",
    d: "M2.031,0H3.969A2.031,2.031,0,0,1,6,2.031v.938A2.031,2.031,0,0,1,3.969,5H2.031A2.031,2.031,0,0,1,0,2.969V2.031A2.031,2.031,0,0,1,2.031,0Z",
    transform: "translate(51.29 303.947)",
    fill: "#E75A7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18970",
    "data-name": "Rectangle 18970",
    d: "M2.031,0H3.969A2.031,2.031,0,0,1,6,2.031v.938A2.031,2.031,0,0,1,3.969,5H2.031A2.031,2.031,0,0,1,0,2.969V2.031A2.031,2.031,0,0,1,2.031,0Z",
    transform: "translate(51.29 312.947)",
    fill: "#E75A7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18971",
    "data-name": "Rectangle 18971",
    d: "M2.031,0H3.969A2.031,2.031,0,0,1,6,2.031v.938A2.031,2.031,0,0,1,3.969,5H2.031A2.031,2.031,0,0,1,0,2.969V2.031A2.031,2.031,0,0,1,2.031,0Z",
    transform: "translate(51.29 322.947)",
    fill: "#E75A7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18972",
    "data-name": "Rectangle 18972",
    d: "M2.031,0H3.969A2.031,2.031,0,0,1,6,2.031v.938A2.031,2.031,0,0,1,3.969,5H2.031A2.031,2.031,0,0,1,0,2.969V2.031A2.031,2.031,0,0,1,2.031,0Z",
    transform: "translate(51.29 331.947)",
    fill: "#E75A7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18973",
    "data-name": "Rectangle 18973",
    d: "M2,0H4A2,2,0,0,1,4,4H2A2,2,0,0,1,2,0Z",
    transform: "translate(51.29 341.947)",
    fill: "#E75A7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41036",
    "data-name": "Path 41036",
    d: "M21.007.382a.382.382,0,0,1-.382.382H.382A.382.382,0,0,1,0,.382H0A.382.382,0,0,1,.382,0H20.625a.382.382,0,0,1,.382.382Zm0,3.056a.382.382,0,0,0-.382-.382H.382A.382.382,0,0,0,0,3.438H0a.382.382,0,0,0,.382.382H20.625a.382.382,0,0,0,.382-.382Zm0,6.875a.382.382,0,0,0-.382-.382H.382A.382.382,0,0,0,0,10.313H0a.382.382,0,0,0,.382.382H20.625a.382.382,0,0,0,.382-.382Zm0,3.438a.382.382,0,0,0-.382-.382H.382A.382.382,0,0,0,0,13.751H0a.382.382,0,0,0,.382.382H20.625a.382.382,0,0,0,.382-.382Zm0,6.111a.382.382,0,0,0-.382-.382H.382A.382.382,0,0,0,0,19.862H0a.382.382,0,0,0,.382.382H20.625a.382.382,0,0,0,.382-.382Zm0,3.056a.382.382,0,0,0-.382-.382H.382A.382.382,0,0,0,0,22.918H0a.382.382,0,0,0,.382.382H20.625a.382.382,0,0,0,.382-.382Zm0,6.111a.382.382,0,0,0-.382-.382H.382A.382.382,0,0,0,0,29.029H0a.382.382,0,0,0,.382.382H20.625a.382.382,0,0,0,.382-.382Zm0,3.056a.382.382,0,0,0-.382-.382H.382A.382.382,0,0,0,0,32.085H0a.382.382,0,0,0,.382.382H20.625a.382.382,0,0,0,.382-.382Zm0,6.493a.382.382,0,0,0-.382-.382H.382A.382.382,0,0,0,0,38.578H0a.382.382,0,0,0,.382.382H20.625a.382.382,0,0,0,.382-.382Zm0,3.056a.382.382,0,0,0-.382-.382H.382A.382.382,0,0,0,0,41.634H0a.382.382,0,0,0,.382.382H20.625a.382.382,0,0,0,.382-.382Z",
    transform: "translate(60.019 304.232)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    d: "M27.888,13.944A13.944,13.944,0,1,1,13.944,0,13.944,13.944,0,0,1,27.888,13.944Z",
    transform: "translate(71.332 312.234) rotate(-22.5)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9113",
    "data-name": "Group 9113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41037",
    "data-name": "Path 41037",
    d: "M6.8,16.292a1.165,1.165,0,0,1-.757-.28L.389,11.168A1.164,1.164,0,0,1,1.9,9.4L6.4,13.26,12.474.66a1.165,1.165,0,0,1,2.1,1.01L7.847,15.635a1.165,1.165,0,0,1-.81.634,1.2,1.2,0,0,1-.24.023Z",
    transform: "translate(82.605 310.839)",
    fill: "#E75A7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingTypeOneTimeIcon);
export default __webpack_public_path__ + "static/media/booking-type-one-time-icon.2a430e8808d2ff06631983e44408c0af.svg";
export { ForwardRef as ReactComponent };